import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatDetail } from "@/lib/api";
import { Lock, ArrowRight } from "lucide-react";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) { toast.error("Passwords do not match."); return; }
    if (pw.length < 8) { toast.error("Password must be at least 8 characters."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Password updated. Please log in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 md:px-8 py-16 md:py-24" data-testid="reset-password-page">
      <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>Password Reset</span></div>
      <h1 className="font-display text-3xl md:text-4xl mv-green-text mt-3 leading-tight">
        Set a new password.
      </h1>
      <form onSubmit={submit} className="mt-8 mv-card p-6 md:p-7 space-y-4">
        {!token && <div className="text-[13px] text-red-600">Missing reset token. Please use the link from your email.</div>}
        <label className="block">
          <span className="text-[12.5px] uppercase tracking-[0.18em]" style={{ color: "var(--mv-muted)" }}>New Password</span>
          <div className="mt-1 relative">
            <Lock size={16} className="absolute left-3.5 top-3.5" style={{ color: "var(--mv-muted)" }} />
            <input type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 rounded-xl border mv-hairline" data-testid="reset-password" />
          </div>
        </label>
        <label className="block">
          <span className="text-[12.5px] uppercase tracking-[0.18em]" style={{ color: "var(--mv-muted)" }}>Confirm Password</span>
          <input type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)}
            className="w-full mt-1 px-4 py-2.5 rounded-xl border mv-hairline" data-testid="reset-confirm" />
        </label>
        <button type="submit" disabled={loading || !token} className="btn-gold w-full justify-center disabled:opacity-60" data-testid="reset-submit">
          {loading ? "Updating…" : (<>Update Password <ArrowRight size={16}/></>)}
        </button>
        <p className="text-[13px] pt-2" style={{ color: "var(--mv-muted)" }}>
          <Link to="/login" className="mv-green-text underline">Back to login</Link>
        </p>
      </form>
    </div>
  );
}
